// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file nodebase/v1/event.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PageRequest, PageResponse, RequestMeta } from "./common_pb";
import { file_nodebase_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file nodebase/v1/event.proto.
 */
export const file_nodebase_v1_event: GenFile = /*@__PURE__*/
  fileDesc("Chdub2RlYmFzZS92MS9ldmVudC5wcm90bxILbm9kZWJhc2UudjEinAEKBUV2ZW50EgoKAmlkGAEgASgJEhQKDHdvcmtzcGFjZV9pZBgCIAEoCRIMCgR0eXBlGAMgASgJEicKCHNldmVyaXR5GAQgASgOMhUubm9kZWJhc2UudjEuU2V2ZXJpdHkSDgoGc291cmNlGAUgASgJEhQKDHBheWxvYWRfanNvbhgGIAEoCRIUCgxjcmVhdGVkX3VuaXgYByABKAMieQoRTGlzdEV2ZW50c1JlcXVlc3QSJgoEbWV0YRgBIAEoCzIYLm5vZGViYXNlLnYxLlJlcXVlc3RNZXRhEhQKDHdvcmtzcGFjZV9pZBgCIAEoCRImCgRwYWdlGAMgASgLMhgubm9kZWJhc2UudjEuUGFnZVJlcXVlc3QiYQoSTGlzdEV2ZW50c1Jlc3BvbnNlEiIKBmV2ZW50cxgBIAMoCzISLm5vZGViYXNlLnYxLkV2ZW50EicKBHBhZ2UYAiABKAsyGS5ub2RlYmFzZS52MS5QYWdlUmVzcG9uc2UqZAoIU2V2ZXJpdHkSGAoUU0VWRVJJVFlfVU5TUEVDSUZJRUQQABIRCg1TRVZFUklUWV9JTkZPEAESFAoQU0VWRVJJVFlfV0FSTklORxACEhUKEVNFVkVSSVRZX0NSSVRJQ0FMEAMyXQoMRXZlbnRTZXJ2aWNlEk0KCkxpc3RFdmVudHMSHi5ub2RlYmFzZS52MS5MaXN0RXZlbnRzUmVxdWVzdBofLm5vZGViYXNlLnYxLkxpc3RFdmVudHNSZXNwb25zZUK6AQoPY29tLm5vZGViYXNlLnYxQgpFdmVudFByb3RvUAFaTmdpdC5taXRlbGFiLmNvbS9ub2RlYmFzZS9ub2RlYmFzZS9wYWNrYWdlcy9wcm90b2NvbC9nZW4vbm9kZWJhc2UvdjE7bm9kZWJhc2V2MaICA05YWKoCC05vZGViYXNlLlYxygILTm9kZWJhc2VcVjHiAhdOb2RlYmFzZVxWMVxHUEJNZXRhZGF0YeoCDE5vZGViYXNlOjpWMWIGcHJvdG8z", [file_nodebase_v1_common]);

/**
 * @generated from message nodebase.v1.Event
 */
export type Event = Message<"nodebase.v1.Event"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * Namespaced type: cron.failed | service.crashed | worker.offline |
   * quota.warning | user.notify | ...
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: nodebase.v1.Severity severity = 4;
   */
  severity: Severity;

  /**
   * node_ref + optional addon/service
   *
   * @generated from field: string source = 5;
   */
  source: string;

  /**
   * @generated from field: string payload_json = 6;
   */
  payloadJson: string;

  /**
   * @generated from field: int64 created_unix = 7;
   */
  createdUnix: bigint;
};

/**
 * Describes the message nodebase.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_event, 0);

/**
 * @generated from message nodebase.v1.ListEventsRequest
 */
export type ListEventsRequest = Message<"nodebase.v1.ListEventsRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * @generated from field: nodebase.v1.PageRequest page = 3;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message nodebase.v1.ListEventsRequest.
 * Use `create(ListEventsRequestSchema)` to create a new message.
 */
export const ListEventsRequestSchema: GenMessage<ListEventsRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_event, 1);

/**
 * @generated from message nodebase.v1.ListEventsResponse
 */
export type ListEventsResponse = Message<"nodebase.v1.ListEventsResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.Event events = 1;
   */
  events: Event[];

  /**
   * @generated from field: nodebase.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message nodebase.v1.ListEventsResponse.
 * Use `create(ListEventsResponseSchema)` to create a new message.
 */
export const ListEventsResponseSchema: GenMessage<ListEventsResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_event, 2);

/**
 * @generated from enum nodebase.v1.Severity
 */
export enum Severity {
  /**
   * @generated from enum value: SEVERITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SEVERITY_INFO = 1;
   */
  INFO = 1,

  /**
   * @generated from enum value: SEVERITY_WARNING = 2;
   */
  WARNING = 2,

  /**
   * @generated from enum value: SEVERITY_CRITICAL = 3;
   */
  CRITICAL = 3,
}

/**
 * Describes the enum nodebase.v1.Severity.
 */
export const SeveritySchema: GenEnum<Severity> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_event, 0);

/**
 * EventService exposes the reserved notification channel (technical plan §3.5).
 * P1 has producers (worker.offline, device revoked, …) but no push transport;
 * ListEvents is cursor-pull, used for debugging and as the P2 foundation.
 *
 * @generated from service nodebase.v1.EventService
 */
export const EventService: GenService<{
  /**
   * @generated from rpc nodebase.v1.EventService.ListEvents
   */
  listEvents: {
    methodKind: "unary";
    input: typeof ListEventsRequestSchema;
    output: typeof ListEventsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_nodebase_v1_event, 0);

